import * as d3 from "d3";
import h337 from "heatmap.js";
import $ from "jquery";
import { toastInfo, toastInfoSingle } from "src/components/Planner/controller";
import {
  CleanupAll,
  cleanupMethods,
  isPlannerBusy,
  setMode,
  toggleEditableWallViewMode,
  toolbarSwitchSet
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import { uDev } from "src/components/Planner/planner/uDev";
import {
  calcWifiHeatmap,
  getAPs,
  setWifiBand,
  WIFI_BAND,
  WIFI_BANDS,
  WIFICALC
} from "src/components/Planner/planner/wificalc";
import { ts } from "src/utils/translate";

export let wifiheatmap;
export let wifiTipTimeout;

//E.I.R.P. = AP power (dBm) + antenna gain (dBi) – cable attn (dB) – plug attn (dB)

export function initWifiCalc() {
  if (typeof cleanupMethods != 'undefined') {
    cleanupMethods.push(function () {
      if (PlannerGlobals.mode == 'wificalc') {
        removeWifiHeatmap();
        toolbarSwitchSet("wifiradius-display", "off");
        $('#wificalc-btn').find(".fa-wifi").css("color", "");
        setWifiBand(WIFI_BANDS._5);
        $('#signal-strength').hide();
        $('.signal-legend').css('display', 'none');
      }
    });
  }

  if (typeof setMode != 'undefined') {
    setMode['wificalc'] = function () {
      if (!PlannerGlobals.isInQuote) {
        var busyReason = isPlannerBusy();
        if (busyReason) {
          toastInfo(busyReason);
          return false;
        }
      }

      if (PlannerGlobals.isDragging || !$('#wificalc-btn').is(':visible')) {
        return;
      }

      if (PlannerGlobals.mode == 'wificalc' && WIFI_BAND == WIFI_BANDS._5) { // change from 5ghz mode to basic
        setMode.basic();
        if (PlannerGlobals.plannerEditableWallViewEnable === true) {
          toggleEditableWallViewMode(true);
        }
      }
      else if (PlannerGlobals.mode == 'wificalc' && WIFI_BAND == WIFI_BANDS._24) { // change from 2.4ghz mode to 5ghz
        setWifiBand(WIFI_BANDS._5);
        $('#wifiradius-display').text('5GHz');
        calcAndShowWifiHeatmap();
        convertWifiFOToImage();
      }
      else { // change from basic to 2.4ghz mode
        var APs = getAPs();
        if (!!APs.length) {
          CleanupAll();
          setWifiBand(WIFI_BANDS._24);
          toolbarSwitchSet("wifiradius-display", "on");
          $('#wifiradius-display').text('2.4GHz');
          $('#wificalc-btn').find(".fa-wifi").css("color", "deepskyblue");
          calcAndShowWifiHeatmap();
          convertWifiFOToImage();
          $('.signal-legend').css('display', '-webkit-box');
          PlannerGlobals.mode = 'wificalc';
          tryShowWifiTip();
        } else {
          toastInfoSingle(ts('p_wlan_nodevs', 'No Access Points placed.'));
        }
      }
    }
  }

}

export function showCalculatedWifiHeatmap(increment = 10, overshoot = 150) {
  if (!wifiheatmap) {
    var fObject = d3.select('#containerSVG').append('foreignObject')
      .attr('id', 'heatmap_fobj')
      .attr('x', 0 - overshoot)
      .attr('y', 0 - overshoot)
      .attr('width', 900 + overshoot * 2)
      .attr('height', 900 + overshoot * 2)
      .style('pointer-events', 'none')
      .style('z-index', '0');

    fObject.append("xhtml:div")
    .attr('id', 'heatmap_body')
    .style("margin", "0px")
    .style("padding", "0px")
    .style("background-color", "none")
    .style("width", (900 + overshoot * 2) + "px")
    .style("height", (900 + overshoot * 2) + "px")
    .style('background', 'none');

    var maxOpacity = PlannerGlobals.isInQuote ? 0.84 : 0.6;
    var minOpacity = PlannerGlobals.isInQuote ? 0.10 : 0.03;

    var heatmapBodyElem = document.getElementById('heatmap_body');

    if (heatmapBodyElem) {
      wifiheatmap = h337.create({
        container: heatmapBodyElem,
        radius: increment * 20 / 10,
        maxOpacity: maxOpacity,
        minOpacity: minOpacity,
        blur: 0.85,
        gradient: {
          0.15: "rgb(0,0,255)",
          0.48: "rgb(0,255,0)",
          0.9: "yellow",
          1: "rgb(255,0,0)"
        }
      });
    }
  }
  if (wifiheatmap) {
    wifiheatmap.setData({
      min: 0, max: 100, data: WIFICALC.getPts()
      .filter(function (pt) { return pt.value > 0; })
      .map(function (pt) { return { x: pt.x + overshoot, y: pt.y + overshoot, value: pt.value }; })
    });
  }
}

export function calcAndShowWifiHeatmap(increment = 10, overshoot = 150) {
  const t1 = performance.now();
  calcWifiHeatmap(increment, overshoot);
  const t2 = performance.now();
  showCalculatedWifiHeatmap(increment, overshoot);
  const t3 = performance.now();
}

export function removeWifiHeatmap() {
  d3.select('#heatmap-svg-img').remove();
  if (wifiheatmap) {
    wifiheatmap = null;
    d3.select('#heatmap_fobj').remove();
    toolbarSwitchSet("wifiradius-display", "off");
    $('#wificalc-btn').find(".fa-wifi").css("color", "");
  }
}

export function tryShowWifiTip() {
  if (PlannerGlobals.isInQuote) {
    return;
  }
  if (wifiTipTimeout) {
    clearTimeout(wifiTipTimeout);
  }
  wifiTipTimeout = setTimeout(function () {
    if (wifiheatmap && !uDev.outerBorderExists()) {
      toastInfoSingle(ts('p_wlan_markouter', "For more accurate results, please mark the outer walls. <b>Hotkey: 6</b><br>"));
    }
  }, 1000);
}

export function redrawWifiIfNeeded() {

  if (PlannerGlobals.mode == 'wificalc' && $('#heatmap-svg-img').length === 0) {
    var APs = getAPs();
    if (!APs.length) {
      setMode.basic();
    }
    else {
      calcAndShowWifiHeatmap();
    }
  }
}

/*
export let IS_IN_WORKER;

if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
    IS_IN_WORKER = true;
} else {
    IS_IN_WORKER = false;
}
*/

export function convertWifiFOToImage() {
  var fObject = $('.heatmap-canvas').closest('foreignObject');

  d3.select('#heatmap-svg-img').remove();
  var canvas = document.querySelector('.heatmap-canvas');
  var url = canvas.toDataURL();

  d3.select('#containerSVG').append("svg:image")
  .attr('id', 'heatmap-svg-img')
  .attr("x", fObject.attr('x'))
  .attr("y", fObject.attr('y'))
  .attr("width", fObject.attr('width'))
  .attr("height", fObject.attr('height'))
  .attr("xlink:href", url);

  fObject.remove();
  wifiheatmap = null;

}


